import auth from '@/auth';

/**
 * Authenticate the user with the given credentials.
 *
 * If there is any error with the authentication this action will throw it.
 *
 * @param {Object} context
 * @param {Object} credentials
 * @param {String} credentials.email
 * @param {String} credentials.password
 */
function authenticate({ commit }, { email, password }) {
  commit('setLoadingAuthentication', true)
  return auth.authenticate(email, password)
    .then(() => commit('setLoadingAuthentication', false))
    .catch(err => {
      commit('setLoadingAuthentication', false)
      throw err
    })
}


export default {
  authenticate
}
